import { render } from "./VerticalDivider.vue?vue&type=template&id=4275cf1c"
import script from "./VerticalDivider.vue?vue&type=script&lang=js"
export * from "./VerticalDivider.vue?vue&type=script&lang=js"

import "./VerticalDivider.vue?vue&type=style&index=0&id=4275cf1c&lang=css"
script.render = render

export default script